export default __webpack_public_path__ + "static/media/green-energy.18852803.svg";